import { render, staticRenderFns } from "./LogoPZK.vue?vue&type=template&id=cc6da938&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc6da938')) {
      api.createRecord('cc6da938', component.options)
    } else {
      api.reload('cc6da938', component.options)
    }
    module.hot.accept("./LogoPZK.vue?vue&type=template&id=cc6da938&", function () {
      api.rerender('cc6da938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/svg/LogoPZK.vue"
export default component.exports